import * as React from 'react';
import classnames from 'classnames';
import { Loader } from '@grandvisionhq/common';
import { useIntl, statusSuccess } from '@grandvisionhq/state';
import { useAddressBookList } from '../../../../hooks/common/use-address-book-list.js';
import { SelectAddress } from './SelectAddress.js';

const SelectAddressContainer = ({ addressSummary , selected , onChange , className , title ,  })=>{
    const { getLabel  } = useIntl();
    const addressBook = useAddressBookList();
    const labels = React.useMemo(()=>({
            preferredBilling: getLabel('checkout.addressBook.tag.preferredBillingAddress'),
            preferredShipping: getLabel('checkout.addressBook.tag.preferredDeliveryAddress')
        })
    , [
        getLabel
    ]);
    const handleChange = React.useCallback((event)=>{
        if (!statusSuccess(addressBook)) {
            return;
        }
        const id = event.currentTarget.value;
        const address = addressBook.result.find((a)=>a.id === id
        );
        address && (onChange === null || onChange === void 0 ? void 0 : onChange(address));
    }, // adding onChange to the dependency array might cause unnecessary updates
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        addressBook
    ]);
    if (!statusSuccess(addressBook)) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    return /*#__PURE__*/ React.createElement("fieldset", {
        className: classnames('select-address', className),
        "data-t": "select-address",
        "aria-label": title
    }, addressSummary && addressBook.result.map((address)=>{
        const { id , addressTypes  } = address;
        const isPreferredBillingAddress = addressTypes.includes('billing');
        const isPreferredDeliveryAddress = addressTypes.includes('delivery');
        const hasPreferredTag = isPreferredBillingAddress || isPreferredDeliveryAddress;
        const addressSummaryElement = /*#__PURE__*/ React.cloneElement(addressSummary, {
            values: address
        });
        return /*#__PURE__*/ React.createElement(SelectAddress, {
            addressSummaryElement: addressSummaryElement,
            handleChange: handleChange,
            hasPreferredTag: hasPreferredTag,
            id: id,
            isPreferredBillingAddress: isPreferredBillingAddress,
            isPreferredDeliveryAddress: isPreferredDeliveryAddress,
            key: id,
            labels: labels,
            selected: selected
        });
    }));
};

export { SelectAddressContainer };
//# sourceMappingURL=SelectAddressContainer.js.map
